import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
 fetchGrammarTopicById,
 fetchGrammarSubTopicById,
 deleteGrammarSubTopic,
} from "./adminGrammarService";
import GrammarSubTopicForm from "./GrammarSubTopicForm";
import "../../blog/tongueTwister.css";

const AdminGrammarSubTopicPage = () => {
 const { topicId } = useParams();
 const navigate = useNavigate();
 const [topic, setTopic] = useState(null);
 const [loading, setLoading] = useState(true);
 const [showForm, setShowForm] = useState(false);
 const [editingSubTopic, setEditingSubTopic] = useState(null);

 useEffect(() => { loadTopic(); }, [topicId]);

 const loadTopic = async () => {
 setLoading(true);
 const res = await fetchGrammarTopicById(topicId);
 if (res.status === 200 && res.data) {
 setTopic(res.data);
 } else {
 alert(res.message || "Failed to load topic");
 }
 setLoading(false);
 };

 const handleEditSubTopic = async (subTopicId) => {
 const res = await fetchGrammarSubTopicById(subTopicId);
 if (res.status === 200 && res.data) {
 setEditingSubTopic(res.data);
 setShowForm(true);
 } else {
 alert(res.message || "Failed to load sub-topic");
 }
 };

 const handleDeleteSubTopic = async (id) => {
 if (!window.confirm("Delete this sub-topic?")) return;
 const res = await deleteGrammarSubTopic(id);
 if (res.status === 200 || res.status === 204) {
 loadTopic();
 } else {
 alert(res.message);
 }
 };

 const onSaved = () => {
 setShowForm(false);
 setEditingSubTopic(null);
 loadTopic();
 };

 if (loading) return <div className="admin-container"><p>Loading...</p></div>;
 if (!topic) return <div className="admin-container"><p>Topic not found</p></div>;

 return (
 <div className="admin-container">
 <button onClick={() => navigate("/admin/content/grammar")} style={{ marginBottom: 16, background: "none", border: "none", color: "#019095", cursor: "pointer", fontWeight: 600 }}>
 ← Back to Topics
 </button>

 <div className="admin-header">
 <h2>{topic.icon} {topic.title}</h2>
 <button onClick={() => { setEditingSubTopic(null); setShowForm(true); }}>+ New Sub Topic</button>
 </div>
 <p style={{ color: "#666", marginBottom: 20 }}>{topic.description}</p>

 {showForm && (
 <GrammarSubTopicForm
 subTopic={editingSubTopic}
 grammarTopicId={Number(topicId)}
 onSaved={onSaved}
 onCancel={() => { setShowForm(false); setEditingSubTopic(null); }}
 />
 )}

 <table className="announcement-table">
 <thead>
 <tr>
 <th>Title</th>
 <th>Sort Order</th>
 <th>Sections</th>
 <th>Created</th>
 <th>Actions</th>
 </tr>
 </thead>
 <tbody>
 {(!topic.subTopics || topic.subTopics.length === 0) ? (
 <tr><td colSpan="5">No sub-topics yet</td></tr>
 ) : (
 topic.subTopics.map((st) => (
 <tr key={st.id}>
 <td style={{ fontWeight: 600 }}>{st.title}</td>
 <td style={{ textAlign: "center" }}>{st.sortOrder ?? "—"}</td>
 <td style={{ textAlign: "center" }}>{st.sectionCount || 0}</td>
 <td>{st.createdAt ? new Date(st.createdAt).toLocaleDateString() : "—"}</td>
 <td>
 <button onClick={() => handleEditSubTopic(st.id)}>Edit</button>
 <button className="delete-btn" onClick={() => handleDeleteSubTopic(st.id)}>Delete</button>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 </div>
 );
};

export default AdminGrammarSubTopicPage;
